export default {
  translations: { // namespace
    home: {
      messageTitle: 'Vamos criar o seu próximo anúncio em vídeo?',
      message: 'O Multiply é uma ferramenta para criar de forma fácil e rápida anúncios em vídeo dos seus produtos.',
      emailInput: 'Informe seu e-mail',
      submitEmail: 'Continuar',
      emailPlaceholder: 'Digite aqui...',
      downloadAppTitle: 'Fazer download ou acessar o app'
    }
  }
};
